<template>
  <main id='wrapper'>
    <!--<PasswordProtection />-->
    <MainHeader />
    <ViewTransitions @transitionStarted="started" @transitionEnded="ended"/>
    <MainFooter :class='{hide: transitionActive}' />
  </main>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { routeStore } from '@/utils'
import PasswordProtection from '@/components/Utils/PasswordProtection.vue'
import MainFooter from '@/components/Navigation/MainFooter.vue'

//Get route so we know where we are.
const route = useRoute();
const routes = routeStore();

//Setup Kirby (Timeout just so we don't load it too quickly.)
const kql = useStore();
setTimeout(function() { kql.loadPageAndSite(route.path, route.name) });

//Bind Router and KQLStore
watch(route, (route) => kql.loadPage(route.path, route.name));

//Watch transition emits.
const transitionActive = ref(false)
const started = () => {transitionActive.value = true}
const ended = () => {transitionActive.value = false}
</script>

<style scoped>
  main {
    position: relative;
  }

  main > main {
    transition: all 500ms ease-out;
    opacity: 1;
    filter: blur(0px);
    min-height: calc(100vh - 10rem);
  }

  main footer.hide {
    display: none;
  }

</style>
